import { Grid, InputLabel, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { isNil } from "ramda";
import { Data } from "../../../../store/terminal/types";
import EditTerminalResetSTAN from "./EditTerminalResetSTAN";

interface Props {
  terminal: Data | undefined;
  isResetSTANAllowed?: boolean
}

export default function TerminalReadOnlyFields({
                                                 terminal, isResetSTANAllowed
                                               }: Props): React.ReactElement {
  const [fields, setFields] = useState([
    {
      label: "Crypto Date",
      value: !isNil(terminal?.attributes.DateInjected)
        ? moment(terminal?.attributes.DateInjected)
          .local()
          .format("DD/MM/YYYY HH:mm:ss A")
        : "",
    },
    { label: "Pin Pad ID", value: terminal?.attributes.PPID },
    { label: "AXISPayVersion", value: terminal?.attributes.AXISPayVersion },
    { label: "STAN", value: terminal?.attributes.STAN },
    { label: "Temp Password", value: terminal?.attributes.TempPassword },
  ]);
  return (
    <Grid container xs={12} spacing={2}>

      {fields.map((field) => {
        return (
          <Grid item key={field.label} xs={12} md>
            <InputLabel id={field.label} shrink>
              {field.label}
            </InputLabel>
            <Box>
              {field.label !== 'STAN' && <Typography>{field.value}</Typography>}
              {field.label === 'STAN' &&
                <EditTerminalResetSTAN terminal={terminal} isResetSTANAllowed={isResetSTANAllowed}/>
              }
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
}
